import { Flex } from '@servicetitan/anvil2';
import { ReactNode } from 'react';

export const StepWrapper = ({ children }: { children: ReactNode }) => {
    return (
        <Flex
            direction="column"
            gap="4"
            alignItems="center"
            grow={1}
            style={{ minHeight: 'calc(100dvh - 5.5rem)' }}
        >
            {children}
        </Flex>
    );
};
